"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogWriter = void 0;
var createLogWriter_1 = require("./factories/createLogWriter");
Object.defineProperty(exports, "createLogWriter", { enumerable: true, get: function () { return createLogWriter_1.createLogWriter; } });
